import React from 'react';
import Field from '../../../components/Fields/Field';
import SelectListField from '../../../components/Fields/SelectListField';
import TextboxControl from '../../../components/Fields/TextboxControl';
import { ControlProps, FieldProps, LabelProps } from '../../../components/Fields/Types';
import Title from '../../../components/Headers/Title';
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';

interface EmployeeControlProps {
    getLabelProps: (string) => LabelProps
    getControlProps: (string) => ControlProps
    getFieldProps: (string) => FieldProps
    disabled: boolean
}

const EmployeeControl: React.FC<EmployeeControlProps> = ({ getLabelProps, getControlProps, getFieldProps, disabled }) => {
    const departments = useSelectListOptions('api/v1/selectlist/Departments', '-- Select department');

    return (
        <>
            <Title text={'Employee'} size={5} />
            <Field {...getLabelProps('employee.firstName')}>
                <TextboxControl {...getControlProps('employee.firstName')} disabled={disabled} />
                <TextboxControl {...getControlProps('employee.prePosition')} width={'40%'} disabled={disabled} />
                <TextboxControl {...getControlProps('employee.lastName')} disabled={disabled} />
            </Field>
            <SelectListField {...getFieldProps('employee.departmentId')} options={departments} disabled={disabled} />
        </>
    );
}
export default EmployeeControl;